export default __webpack_public_path__ + "static/media/icon_zoom_out.6cda708d.svg";